export default class Back {
  constructor(el) {
    this.el = el;

    el.addEventListener('click', e => {
      history.back();
      e.preventDefault();
    }, false);
  }
}
